import 'babel-polyfill';
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import VueCropper from "vue-cropper";
import Vuex from "vuex";
import store from "./store/store.js";
// import md5 from 'js-md5'
Vue.config.productionTip = false;
import "./ieUtils";
// 自动退出文件路径
import auto_loginout from './utils/auto_loginout'


import JSEncrypt from "jsencrypt";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
Vue.use(Vuex);
import $ from "jquery";
Vue.prototype.$bus = Vue.prototype.$bus || new Vue();
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
Vue.use(Viewer);
Vue.use(auto_loginout)
//配置项
Viewer.setDefaults({
    defaultOptions: {
        zIndex: 9999
    },
    Options: {
        inline: true, //启用内敛模式
        button: true,
        navbar: false, //显示缩略图
        title: false, //显示标题
        toolbar: true, //工具栏按钮，可单独配置
        tooltip: true, //工具提示
        movable: false, //移动
        zoomable: true, //缩放
        rotatable: true, //旋转
        scalable: true, //翻转
        transition: true, //变换
        fullscreen: true, //全屏
        keyboard: true,
        url: "data-source"
    }
});

// 机构绑定加密方式

// 导入 crypto-js 包
// import cryptoJS from "crypto-js";
// //把AES加密vue原型里
// Vue.prototype.$cryptoJS = cryptoJS;

Vue.prototype.$version = "v1";
Vue.prototype.$version1 = "v1";
Vue.prototype.$version2 = "v2";
// cas登录
Vue.prototype.$casLogin = "http://casmp.yiigle.com";
Vue.prototype.$casLoginUrl = "https://ucenter.yiigle.com";
Vue.prototype.$LoginToUrl = "http://journal.ceshi.yiigle.com/index.do";
Vue.prototype.$testIden = "";
Vue.prototype.$journalDb = "";
window.iden = "";
window.appId = "6kLvKOGL1h8uICWE";
Vue.prototype.$getRsaCode = function(str) {
    let pubKey = window.localStorage.getItem("gy");
    let encryptStr = new JSEncrypt();
    encryptStr.setPublicKey(pubKey); // 设置 加密公钥
    let data = encryptStr.encrypt(str.toString()); // 进行加密
    return data;
};

Vue.prototype.$encryptionAES = function(params) {
    let keyStr = "fEnA3wqYub0HMn8f8NK89icDf7mjYbVBBk3ewrs8Auj";
    let key = this.$cryptoJS.enc.Utf8.parse(keyStr);
    let srcs = this.$cryptoJS.enc.Utf8.parse(params);
    let encrypted = this.$cryptoJS.AES.encrypt(srcs, key, {
        mode: this.$cryptoJS.mode.CBC,
        padding: this.$cryptoJS.pad.ZeroPadding
    });
    return encrypted.toString();
};

let time = "3600";
let data = new Date().getTime();
if (data - localStorage.getItem("time") >= time) {}
import languages from "./components/mobileLogin/language.js";

// 获取语种文字
Vue.prototype.$getText = function(modelT) {
    // console.log(modelT,'转换前');
    // console.log(localStorage.getItem("languageValue"),'localStorage.getItem("languageValue")----------------');
    let lang = localStorage.getItem("languageValue") ?localStorage.getItem("languageValue") :"zh";
    let valueT = "";
    // console.log(lang,'lang');
    if (localStorage.getItem("languageValue")=='undefined') {
        lang='zh'
        localStorage.setItem("languageValue",lang)
    }
    for (let i in languages[lang]) {
        // console.log(modelT == i,'modelT == i');
        if (modelT == i) {
            // console.log(languages[lang][i],'赋值前 ');
            valueT = languages[lang][i];
        }
    }
    // console.log(valueT,'转换后');
    return valueT;
};
// 语种切换
Vue.prototype.$changeLang = function() {
    let lang = localStorage.getItem("languageValue");
    localStorage.setItem("languageValue", lang == "en" ? "zh" : "en");
    this.$forceUpdate();
};
import "@/api/axios.js";
import "@/assets/css/common.css";
Vue.use(ElementUI);
Vue.use(VueCropper);
/* eslint-disable no-new */
Vue.directive("drag", {
    bind(el, bindings) {
        // console.log($(el).find('.modalWindow__top'));
        let dom = $(el).find('.modalWindow__top')[0]||$(el).find('.el-dialog__header')[0]
        dom.onmousedown = function(e) {
            var disx = e.pageX - el.offsetLeft;
            var disy = e.pageY - el.offsetTop;
            document.onmousemove = function(e) {
                el.style.left = e.pageX - disx + "px";
                el.style.top = e.pageY - disy + "px";
            };
            document.onmouseup = function() {
                document.onmousemove = document.onmouseup = null;
            };
        };
    }
});

Vue.filter("fillingZero", res => {
    if (res) {
        let num = res.toString();
        if (num.indexOf(".") == -1) {
            return num + ".00";
        } else {
            let numBefore = num.split(".")[0];
            let numAfter = num.split(".")[1];
            let lastNum = 0.0;
            if (numAfter.length > 2) {
                numAfter = numAfter.substring(0, 2);
                lastNum = numBefore + "." + numAfter;
            } else if (numAfter.length == 2) {
                lastNum = res;
            } else {
                lastNum = numBefore + "." + numAfter + "0";
            }
            return lastNum;
        }
    } else {
        return "0.00";
    }
});
new Vue({
    el: "#app",
    router,
    store,
    components: { App },
    template: "<App/>"
});


// WEBPACK FOOTER //
// ./src/main.js